import { Heart } from "lucide-react";
import { AVATARS } from "@/data/exercises";
import { getGardien } from "@/data/gardiens";

export default function ResidentPortrait({ name, avatar, gardienId, className = "", testId = "resident-portrait", alive = false }) {
  const g = gardienId ? getGardien(gardienId) : null;
  return (
    <div className={`flex items-start justify-center gap-3 sm:gap-6 ${className}`} data-testid={testId}>
      <figure className="text-center soft-in">
        <img src={avatar || AVATARS[0]} alt={name} data-testid={`${testId}-image`}
          className="w-32 h-32 sm:w-44 sm:h-44 rounded-full object-cover object-top border-[6px] border-amber-200 shadow-[0_20px_40px_rgb(0,0,0,0.08)] mx-auto" />
        <figcaption className="font-serif-display text-xl sm:text-2xl text-gray-800 mt-3">{name}</figcaption>
      </figure>
      {g && (
        <>
          <Heart className="w-7 h-7 sm:w-9 sm:h-9 text-rose-300 fill-rose-200 mt-12 sm:mt-[4.25rem] shrink-0 gentle-float" />
          <figure className="text-center soft-in" style={{ animationDelay: "120ms" }}>
            <div className="relative w-32 h-32 sm:w-44 sm:h-44 mx-auto">
              <img src={g.image} alt={g.name} data-testid={`${testId}-gardien`}
                className={`w-full h-full rounded-full object-cover object-top border-[6px] shadow-[0_20px_40px_rgb(0,0,0,0.08)] ${alive ? "gardien-alive" : ""}`} style={{ borderColor: `${g.color}55` }} />
              {g.familiar && <img src={g.familiar.image} alt={g.familiar.name} data-testid={`${testId}-familiar`}
                className={`absolute -bottom-1 -right-1 w-[42%] h-[42%] rounded-full object-cover border-4 border-white shadow-md ${alive ? "familiar-alive" : ""}`} />}
              {alive && <span className="alive-sparkle -top-1 left-2" aria-hidden="true" />}
              {alive && <span className="alive-sparkle top-4 -right-3" style={{ animationDelay: "1.4s" }} aria-hidden="true" />}
            </div>
            <figcaption className="font-serif-display text-xl sm:text-2xl text-gray-800 mt-3">{g.name}</figcaption>
            {g.familiar && <p className="font-patient text-gray-500 -mt-0.5">et {g.familiar.name}</p>}
          </figure>
        </>
      )}
    </div>
  );
}
